import axios from "axios";
import { clearCache } from "@/lib/cache";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// Sessie 30 dagen: bij een verlopen access-token één keer vernieuwen en het verzoek herhalen.
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status !== 401 || cfg._retried || url.startsWith("/auth/")) {
      return Promise.reject(error);
    }
    cfg._retried = true;
    try {
      refreshing = refreshing || api.post("/auth/refresh");
      await refreshing;
      refreshing = null;
      return api(cfg);
    } catch (e) {
      refreshing = null;
      // Sessie is echt verlopen (bijv. wachtwoord gewijzigd): netjes naar inloggen
      // in plaats van een foutmelding over de app.
      if (!window.location.pathname.startsWith("/login")) {
        try {
          clearCache();
        } catch (err) {
          /* cache al leeg */
        }
        window.location.replace("/login");
      }
      return new Promise(() => {});
    }
  }
);

export function apiError(detail) {
  if (detail == null) return "Er ging iets mis. Probeer het opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STATUSES = {
  CONCEPT: { label: "Concept", hex: "#94A3B8", badge: "bg-slate-100 text-slate-700 border-slate-300" },
  INGEPLAND: { label: "Ingepland", hex: "#3B82F6", badge: "bg-blue-100 text-blue-800 border-blue-300" },
  ONDERWEG: { label: "Onderweg", hex: "#F59E0B", badge: "bg-amber-100 text-amber-800 border-amber-300" },
  AFGEROND: { label: "Afgerond", hex: "#10B981", badge: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  GEANNULEERD: { label: "Geannuleerd", hex: "#EF4444", badge: "bg-rose-100 text-rose-800 border-rose-300" },
};

export const EMPLOYEE_COLORS = [
  "#3B82F6", "#10B981", "#F59E0B", "#8B5CF6", "#F43F5E", "#06B6D4", "#84CC16", "#EC4899",
];
